var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import FactAPI from "./FactAPI";
export default class FactPagePopulator {
    static populateFactPage() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!window.location.pathname.startsWith("/fact")) {
                return;
            }
            const urlParams = new URLSearchParams(window.location.search);
            const factID = urlParams.get("id") || pageID;
            if (factID === null || factID === "") {
                return this.redirectTo404();
            }
            const fact = yield this.factAPI.getFact(factID);
            this.populatePageWithFact(fact);
        });
    }
    static redirectTo404() {
        window.location.replace("/404.html");
    }
    static populatePageWithFact(fact) {
        const factElement = document.getElementById("dynamic-fact");
        if (fact.categories.length > 0) {
            const keyCategory = fact.categories[0];
            factElement.classList.add(`vegan-color-${keyCategory.color}`);
        }
        else {
            factElement.classList.add("vegan-color-unknown");
        }
        const factContentElement = factElement.getElementsByClassName("fact-content")[0];
        factContentElement.innerHTML = fact.content;
        const categoriesElement = factElement.querySelector("ul.fact-categories");
        fact.categories.forEach(category => {
            const tagElement = this.createCategoryTag(category);
            categoriesElement === null || categoriesElement === void 0 ? void 0 : categoriesElement.append(tagElement);
        });
        const factDetailElement = factElement.querySelector(".fact-detail");
        factDetailElement.innerHTML = fact.detail;
        const sourcesElement = factElement.querySelector("ul.fact-sources");
        fact.sources.forEach(source => {
            const sourceElement = this.createSourceElement(source);
            sourcesElement === null || sourcesElement === void 0 ? void 0 : sourcesElement.append(sourceElement);
        });
    }
    static createCategoryTag(category) {
        const result = document.createElement("li");
        result.classList.add("fact-category-tag");
        result.innerText = category.name;
        return result;
    }
    static createSourceElement(source) {
        const result = document.createElement("li");
        result.classList.add("source");
        const titleElement = this.createSourceTitleElement(source);
        const textElement = document.createTextNode(" — ");
        const linkElement = this.createSourceLinkElement(source);
        result.appendChild(titleElement);
        result.appendChild(textElement);
        result.appendChild(linkElement);
        return result;
    }
    static createSourceTitleElement(source) {
        const result = document.createElement("span");
        result.classList.add("source-title");
        result.innerText = source.title;
        return result;
    }
    static createSourceLinkElement(source) {
        const result = document.createElement("a");
        result.href = source.link;
        result.innerText = source.organisation || source.author || "Link";
        return result;
    }
}
FactPagePopulator.factAPI = new FactAPI();
//# sourceMappingURL=FactPagePopulator.js.map